import { FunctionComponent, useEffect } from 'react';
import Footer from '../shared/footer/footer';
import TopMenu from '../shared/top-menu/top-menu';
import './home.scss';
import HomeTopBanner from './home-top-banner';
import BuyNowButton from '../shared/buy-now-button/buy-now-button';
import LogoCarousel from './logo-carousel';
import FeaturesOverview from '../features/features-overview';
import { featuredVideosDE, featuredVideosEN } from '../education/all-videos';
import EducationUnit from '../education/education-unit';
import Persona from './persona/persona';
import H2 from '../shared/html-tags/h2';
import P from '../shared/html-tags/p';
import A from '../shared/html-tags/a';
import H3 from '../shared/html-tags/h3';
import DIV from '../shared/html-tags/div';
import '../news/webinars/webinars.scss';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';

export type Props = {};

//To Do: <head>    <link rel="canonical" href="https://predictivesolutions.2x4.de/de/home">    </head>

const Home: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>SPSS PLUS Boost: IBM SPSS Statistics & PS IMAGO PRO.</title>
        <meta
          name="description"
          content="Dein SPSS Statistics Booster für die Datenauswertung, spare Zeit und Kosten. PS IMAGO PRO ist SPSS + Dashboards, Multi-Source Import, Cloud & Co."
        />
        <meta
          name="keywords"
          content="PS IMAGO PRO, SPSS Statistics, Datenanalyse, statistische Auswertung, Predictive Solutions"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/home" />
      </Helmet>

      <div className="page home">
        <TopMenu selected="home"></TopMenu>
        <HomeTopBanner />

        <div className="page-content bg-1">
          <Box className="inner-content">
            <Box className="home-card">
              <div>
                <H2 language="de">
                  Als europaweit einer der größten IBM Solutions Partner bieten wir dir das perfekte
                  Zusammenspiel mit praxiserprobten Funktionen und Charts.
                </H2>

                <div
                  style={{
                    margin: '2rem 0',
                  }}
                >
                  <P language="de">
                    <b>SPSS Statistics</b> ist die führende Softwarelösung für die statistische
                    Datenanalyse. <b>PS IMAGO PRO</b> erweitert dessen Funktionen um zusätzliche
                    Add-Ons, die speziell entwickelt wurden, um das volle Potenzial deiner Daten zu
                    entfalten.
                    <br />
                    Mit unseren Tools zur Erstellung von <b>Berichten</b> und Veröffentlichung von{' '}
                    <b>Ergebnissen</b> in Microsoft Sharepoint kannst Du den gesamten Prozess der
                    Datenanalyse in einer benutzerfreundlichen Umgebung abschließen. Erziele präzise
                    Ergebnisse, während du <b>Zeit und Kosten sparst</b>.
                  </P>
                </div>
              </div>
              {/* 
            <Box className="webinar-teaser">
              <H2 language="de">
                📅 Webinar:
                <br />
                PS IMAGO PRO – Dashboards und mehr mit SPSS Statistics
              </H2>
              <img
                src="/people/DominikGlaser.png"
                alt="Dominik Glaser"
                className="referent-image"
              />
              <p>
                <b>Referent:</b> Dominik Glaser, Entwicklungsingenieur für Aufbau- und
                Verbindungstechnik
              </p>
              <p>
                <b>Termin:</b> 29. April 2025, 10:00 Uhr
              </p>

              <p>
                Erleben Sie live, wie Sie mit <b>PS IMAGO PRO</b> und <b>SPSS Statistics</b>{' '}
                schneller und einfacher zum Ziel kommen.
                <br />
                In diesem Webinar zeigt Ihnen Dominik Glaser:
                <ul>
                  <li>zusätzliche statistische Verfahren und neue Diagrammtypen</li>
                  <li>die Erstellung statischer Dashboards für die Ergebnispräsentation</li>
                  <li>Möglichkeiten zur Automatisierung von Berichten und Datenaktualisierungen</li>
                </ul>
              </p>
              <center>
                <a
                  href="https://events.teams.microsoft.com/event/ee71d525-ae05-4521-adb3-de3cfcec0ccc@7bfa00d9-fcad-461c-818b-ad00e104df6f"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Jetzt kostenlos anmelden
                </a>
                <br />
                <span className="link-info">
                  Der Link führt Dich direkt zur Microsoft Teams Webinar-Anmeldung
                </span>
              </center>
            </Box>
            */}
            </Box>
            <div style={{ textAlign: 'center', margin: '3rem 0' }}>
              <BuyNowButton order={'buy->test'} />
            </div>
          </Box>

          <LogoCarousel />
        </div>

        {/* = Feature Section ========================================================= */}
        <div className="page-content bg-2">
          <div className="inner-content">
            <H2 language="de">Entdecke die volle Kraft von SPSS mit PS IMAGO PRO</H2>
            <P language="de">
              Wir haben mit über 30 SPSS-Partnern und zahlreichen Kunden gesprochen, um zu
              verstehen, welche Funktionen in SPSS Statistics fehlen. Aus diesen wertvollen
              Erkenntnissen und einer intensiven Entwicklungsphase ist PS IMAGO PRO entstanden –
              perfekt abgestimmt auf deine Bedürfnisse.
            </P>
            <FeaturesOverview />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <A language="de" href="/features" className="show-all-features-button">
                Alle Features ansehen
              </A>
            </div>
          </div>
        </div>

        <div className="page-content bg-1">
          <div className="inner-content">
            {/* = Preise Section ============================================================== */}
            <H2 language="de">
              PS IMAGO PRO = SPSS Statistics + Mehr Leistung bei geringeren Kosten*
            </H2>
            <H3 language="de">Warum dies kein Trugschluss ist</H3>
            <P language="de">
              IBM bietet speziellen Value Added Resellern vergünstigte Konditionen für SPSS
              Statistics, um die Software in innovative Lösungen zu integrieren. Diesen Preisvorteil
              geben wir direkt an dich weiter.
            </P>
            <P language="de">
              Doch PS IMAGO PRO ist mehr als nur SPSS zum besseren Preis: Die zusätzlichen
              Funktionen sparen dir wertvolle Arbeitszeit – und in einer Welt, in der Zeit unser
              wertvollstes Gut ist, bedeutet das mehr Effizienz, schnellere Analysen und präzisere
              Entscheidungen.
            </P>
            {/*
            //Obiger Text ist durch ChatGPT verbesert worden:
            IBM bietet neben SPSS Statistics Endkundenlizenzen spezielle, reduzierte Angebote für
            Value Added Reseller an, um SPSS in neue Lösungen integrieren zu können. Diesen
            Preisvorteil geben wir gerne an unsere Kunden weiter. Die neuen, ergänzenden Funktionen
            von PS IMAGO PRO sparen dir außerdem wertvolle Arbeitszeit. In einer Welt, in der Zeit
            unsere kostbarste Ressource ist, bedeutet das mehr Effizienz und bessere Ergebnisse für
            dich.
          */}

            <div style={{ textAlign: 'center', margin: '2rem 0 5rem 0' }}>
              <BuyNowButton order={'test->buy'} />
            </div>

            {/* = Personas Section ============================================================== */}
            <H2 language="de">
              Vielfältige Anwendung: Maßgeschneiderte Lösungen für deine Branche
            </H2>
            <div className="persona-section">
              <Persona
                area={'Business Intelligence'}
                slogan={'„Entscheidungen auf den Punkt gebracht!“'}
                description={() => (
                  <>
                    Dank PS IMAGO PRO habe ich alle KPIs im Blick und reagiere blitzschnell auf
                    Veränderungen. Die automatisierte Berichterstellung spart Zeit und erleichtert
                    strategische Entscheidungen. Ob Marktanalysen oder Umsatzprognosen – unser
                    Unternehmen ist auf Erfolgskurs!
                  </>
                )}
                showcaseurl="/de/showcases/businessintelligence"
              />

              <Persona
                area={'Marktforschung'}
                slogan={'„Konsumentenwünsche und entstehende Trends in Daten erkennen!“'}
                description={() => (
                  <>
                    Mit PS IMAGO PRO analysiere ich im Handumdrehen Umfragedaten und entdecke
                    Trends, bevor sie entstehen. So biete ich maßgeschneiderte Empfehlungen, die
                    sicherstellen, dass Produkte nicht nur gesehen, sondern geliebt werden.
                  </>
                )}
                showcaseurl="/de/showcases/marketresearch"
              />

              <Persona
                area="Gesundheitswesen"
                slogan="„Der Krankheit einen Schritt voraus!“"
                description={() => (
                  <>
                    In der klinischen Forschung sind Präzision und Verlässlichkeit entscheidend. Mit
                    aktuellen Informationen, direkt in der Cloud abrufbar, kann ich komplexe
                    medizinische Daten analysieren und klare Berichte erstellen. Die Gesundheit
                    unserer Patienten hat Priorität, mit dieser Software bleiben wir dem
                    Krankheitsverlauf stets einen Schritt voraus!
                  </>
                )}
                showcaseurl="/de/showcases/healthcare"
              />

              <Persona
                area="Politik"
                slogan="„Politische Entscheidungen mit Durchblick!“"
                description={() => (
                  <>
                    PS IMAGO PRO hilft mir dabei, statistische Analysen verständlich aufzubereiten,
                    sodass unsere Strategien evidenzbasiert und zukunftssicher sind. Ob
                    Bevölkerungsdaten oder Umfragen zur öffentlichen Meinung – mit dieser Lösung
                    treffe ich fundierte Entscheidungen für die Gesellschaft.
                  </>
                )}
                showcaseurl="/de/showcases/politics"
              />

              <Persona
                area="Finanzwesen"
                slogan="„Finanzanalysen, die sich auszahlen!“"
                description={() => (
                  <>
                    PS IMAGO PRO gibt mir die Werkzeuge an die Hand, um Risikoanalysen effizient
                    durchzuführen und präzise Marktprognosen zu erstellen. Echtzeit-Dashboards
                    helfen, Chancen frühzeitig zu erkennen und kluge Investitionsentscheidungen zu
                    treffen.
                  </>
                )}
                showcaseurl="/de/showcases/finance"
              />

              <Persona
                area="Produkt & Qualitätsmanagement"
                slogan="„Exzellenz in jedem Produkt!“"
                description={() => (
                  <>
                    PS IMAGO PRO bietet mir umfassende Einsicht in Qualitätsdaten, sodass ich
                    Optimierungspotenziale sofort identifizieren kann. Ob in der Entwicklungsphase
                    oder beim Markteintritt – die Software ermöglicht, dass jedes Produkt den
                    höchsten Standards entspricht und ein Erfolg wird.
                  </>
                )}
                showcaseurl="/de/showcases/productquality"
              />
              <Persona
                area="Bildung"
                slogan="„Wissen, das begeistert!“"
                description={() => (
                  <>
                    Mit PS IMAGO PRO analysiere ich Leistungsdaten und Bildungsstatistiken, um
                    fundierte Entscheidungen für eine optimierte Lehre zu treffen. Von Schüler- und
                    Studierendenerfolgen bis hin zur Ressourcenplanung – diese Lösung hilft
                    Bildungseinrichtungen, ihre Qualität datenbasiert zu verbessern.
                  </>
                )}
                showcaseurl="/de/showcases/education"
              />
              <Persona
                area="Kommunale Verwaltung"
                slogan="„Effiziente Verwaltung durch datenbasierte Entscheidungen!“"
                description={() => (
                  <>
                    Mit PS IMAGO PRO optimiere ich Verwaltungsprozesse, indem ich Daten zu
                    Bürgeranliegen, Ressourcenplanung und Infrastrukturanalysen effizient auswerte.
                    Ob bei der Verbesserung öffentlicher Dienstleistungen oder der transparenten
                    Berichterstattung – diese Lösung unterstützt kommunale Verwaltungen bei
                    fundierten Entscheidungen für die Gesellschaft.
                  </>
                )}
                showcaseurl="/de/showcases/municipaladministration"
              />
            </div>
          </div>
        </div>

        <div className="page-content bg-2">
          <div className="inner-content">
            {/* = Learning Section ============================================================== */}
            <H2 language="de">
              SPSS & PS IMAGO PRO leicht gemacht: Unsere Tutorial- und Kurs-Empfehlungen
            </H2>
            <DIV language="de">
              Es gibt eine Fülle von Tutorials und Kursen zu dieser Software. Hier sind unsere
              Empfehlungen für dich.
              <br />
              <div className="education-units">
                {featuredVideosDE.map((video, i) => (
                  <EducationUnit
                    key={i}
                    numVideo={video.videoNumber ?? i + 1}
                    name={video.title}
                    description={video.description}
                    duration={video.lengthInSeconds}
                    videolink={video.link}
                    preview={''}
                  />
                ))}
              </div>
              <div className="all-learnings">
                <a href="/de/education" className="link">
                  Mehr entdecken
                </a>
              </div>
            </DIV>
            <DIV language="en">
              There is a wealth of tutorials and courses available for this software. Here are our
              recommendations for you.
              <br />
              <div className="education-units">
                {featuredVideosEN.map((video, i) => (
                  <EducationUnit
                    key={i}
                    numVideo={video.videoNumber ?? i + 1}
                    name={video.title}
                    description={video.description}
                    duration={video.lengthInSeconds}
                    videolink={video.link}
                    preview={''}
                  />
                ))}
              </div>
              <div className="all-learnings">
                <a href="/en/education" className="link">
                  Find more
                </a>
              </div>
            </DIV>
          </div>
        </div>
        {/* = Rezensionen Section ============================================================== 
      <div className="page-content bg-1">
        <div className="inner-content">
          <h2>Rezensionen</h2>
        </div>
      </div>
*/}
        <Footer></Footer>
      </div>
    </>
  );
};

export default Home;
